import React, { useState } from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import Tool, { type ToolButtonComponent } from './Tool';
import ToolButton from '../toolbars/ToolButton';
import AhaMenu from '../toolbars/AhaMenu';
import WhiteboardController from '../controllers/WhiteboardController';
import type EmbeddedTextBehaviors from '../objects/EmbeddedTextBehaviorsV2';

const fontSizes = [8, 10, 12, 14, 16, 18, 20, 24, 30, 36, 48, 72, 144, 288];

const FontSizeButton: ToolButtonComponent = ApplicationView(
  ({ selection, forceRecalculate, tool }) => {
    const controller = useController(WhiteboardController);
    const [fontSize, setFontSize] = useState(
      selection.firstObject().fontSizeWithDefault()
    );
    const handleFontSizeChange = (size: number) => {
      // If text is being edited, stop editing first so it resizes properly.
      selection.forEach((obj: fabric.Object & EmbeddedTextBehaviors) => {
        const field = obj.activeTextField ? obj.activeTextField : obj;
        // Wireframe components do not have an endTextEditing method
        if (typeof field.endTextEditing === 'function') {
          field.endTextEditing();
        }
      });
      controller.actionFocus(false);
      selection.setOnObjects('fontSize', size);
      setFontSize(size);
      Tool.toolActionComplete({ controller });
    };

    return (
      <AhaMenu callback={forceRecalculate}>
        <ToolButton slot='control' tool={tool}>
          {fontSize && Math.round(fontSize)}{' '}
          {!fontSize && <aha-icon icon='fa-solid fa-text-size' />}
        </ToolButton>
        <aha-menu-content>
          {fontSizes.map(size => (
            <aha-menu-item
              key={size}
              onClick={() => handleFontSizeChange(size)}
            >
              {size}
            </aha-menu-item>
          ))}
        </aha-menu-content>
      </AhaMenu>
    );
  }
);

class ToolFontSize extends Tool {
  static toolName = 'Font size';

  static buttonComponent() {
    return FontSizeButton;
  }
}

export default ToolFontSize;
